module.exports = __webpack_public_path__ + "img/1436583177.29251a2b.jpg";